// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Portal Configuration page ───────────────────────────────────────────── */

.ecr-portal-config__card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 18px 22px;
  margin-bottom: 18px;
  min-width: 0;
  box-sizing: border-box;
}

.ecr-portal-config__card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 14px;
}

.ecr-portal-config__hint {
  font-size: 12px;
  font-weight: 400;
  color: #999;
  margin-left: 4px;
}

/* Announcement management rows */
.ecr-portal-config__row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 8px;
  border-top: 1px solid #f0f0f0;
  min-width: 0;
}

.ecr-portal-config__row.disabled .ecr-portal-config__row-body {
  opacity: 0.45;
}

.ecr-portal-config__row-reorder {
  display: flex;
  flex-direction: column;
}

.ecr-portal-config__row-body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.ecr-portal-config__row-title {
  font-size: 13px;
  font-weight: 700;
  color: #1a1a1a;
  display: block;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ecr-portal-config__row-message {
  font-size: 12px;
  color: #666;
  display: block;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Link insert helper inside the editor dialog */
.ecr-portal-config__link-fields {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-top: 10px;
  padding: 10px;
  background: #f8faf5;
  border: 1px dashed #c9dba8;
  border-radius: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ecrOps/EcrOpsPortalConfig.css"],"names":[],"mappings":"AAAA,+EAA+E;;AAE/E;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;AACpB","sourcesContent":["/* ── Portal Configuration page ───────────────────────────────────────────── */\n\n.ecr-portal-config__card {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  padding: 18px 22px;\n  margin-bottom: 18px;\n  min-width: 0;\n  box-sizing: border-box;\n}\n\n.ecr-portal-config__card-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 700;\n  color: #1a1a1a;\n  margin-bottom: 14px;\n}\n\n.ecr-portal-config__hint {\n  font-size: 12px;\n  font-weight: 400;\n  color: #999;\n  margin-left: 4px;\n}\n\n/* Announcement management rows */\n.ecr-portal-config__row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 8px;\n  border-top: 1px solid #f0f0f0;\n  min-width: 0;\n}\n\n.ecr-portal-config__row.disabled .ecr-portal-config__row-body {\n  opacity: 0.45;\n}\n\n.ecr-portal-config__row-reorder {\n  display: flex;\n  flex-direction: column;\n}\n\n.ecr-portal-config__row-body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.ecr-portal-config__row-title {\n  font-size: 13px;\n  font-weight: 700;\n  color: #1a1a1a;\n  display: block;\n  width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ecr-portal-config__row-message {\n  font-size: 12px;\n  color: #666;\n  display: block;\n  width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Link insert helper inside the editor dialog */\n.ecr-portal-config__link-fields {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  margin-top: 10px;\n  padding: 10px;\n  background: #f8faf5;\n  border: 1px dashed #c9dba8;\n  border-radius: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
